import {selectDeviceModelType} from '../../state/selectors/iotDevices';
import {
    setDevice,
    setIsDeviceAssetsInProgress,
    setIsDeviceAssetsReceived,
    updateDeviceData,
} from '../../state/slice/iotDevices';
import {setConsentsFlagsValues} from '../../state/slice/session';
import {dispatch, getState} from '../../state/store';
import log from '../logger/log';
import uamClientService from '../uam/uamClientService';
import uamDeviceService from '../uam/uamDeviceService';
import uamWebSocketService from '../uam/uamWebSocketService';
import uamfClientService from '../uamf/uamfClientService';
import uamfDeviceService from '../uamf/uamfDeviceService';
import uamfWebSocketService from '../uamf/uamfWebSocketService';
import damDeviceHelpers from './damDeviceHelpers';
import damMappingService from './damMappingService';

const isI5Device = (dusn) => damDeviceHelpers.isUamf(dusn);

const getWebSocketService = (dusn) => (isI5Device(dusn) ? uamfWebSocketService : uamWebSocketService);

const getDeviceService = (dusn) => (isI5Device(dusn) ? uamfDeviceService : uamDeviceService);

const setInitialDeviceData = (deviceData) => {
    const initialDeviceData = damMappingService.initialDeviceDataMapping(deviceData);

    dispatch(setDevice(initialDeviceData));
};

const setUserDevices = async () => {
    const devices = await uamClientService.getUserDevices();

    for (const deviceData of devices) {
        setInitialDeviceData(deviceData);
    }

    damDeviceHelpers.resolveCurrentChargerDusn();
};

const setDeviceAssets = async (dusn, isThrowError, isCached) => {
    if (!dusn) return;

    dispatch(setIsDeviceAssetsInProgress(dusn, true));

    try {
        const clientService = isI5Device(dusn) ? uamfClientService : uamClientService;
        const response = await clientService.getDeviceInfo(dusn, isThrowError, isCached);

        if (!response) return;

        dispatch(updateDeviceData(dusn, response));

        if (!isCached) {
            dispatch(setIsDeviceAssetsReceived(dusn, true));
        }

        return response;
    } catch (e) {
        log.error(`damService: Failed to get device assets for ${dusn}`, e);

        throw e;
    } finally {
        dispatch(setIsDeviceAssetsInProgress(dusn, false));
    }
};

const getDeviceConnectionStatus = (dusn, isThrowError) =>
    getDeviceService(dusn).getDeviceConnectionStatus(dusn, isThrowError);

const getUserConsents = async () => {
    const consents = await uamClientService.getUserConsents();

    dispatch(setConsentsFlagsValues(consents));
};

const trackNotification = async (dusn, campaignName, notificationType) => {
    // system notifications don't have a campaignName and shouldn't be tracked
    if (!campaignName) return;

    const modelType = selectDeviceModelType(dusn)(getState());

    await uamClientService.postUserCampaignTracker(campaignName, notificationType, modelType);
};

export default {
    isI5Device,
    getWebSocketService,
    getDeviceService,
    setInitialDeviceData,
    setUserDevices,
    setDeviceAssets,
    getDeviceConnectionStatus,
    getUserConsents,
    trackNotification,
};
